
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'VimeoEmbed',
    props: {
        srcId: { required: false, type: String, default: '' },
        title: { required: false, type: String, default: '' },
        autoplay: { type: Boolean, default: true, required: false },
        autoFitVideoToAspectRatio: { type: Boolean, default: false, required: false },

        /* Can take a single aspect ratio number, or an object with a number pr. breakpoint. If a 'default' is provided is will be used when no breakpoint is active:
           {
                xs: 16/9,
                min-sm,max-md: 4/3
                default: 1/2
           }
        */
        aspectRatio: { type: [Number, Object], default: 16 / 9 },
    },
    setup(props) {
        const activeAspectRatio = computed(() => {
            if (typeof props.aspectRatio === 'number') {
                return props.aspectRatio;
            }

            // Else - object with aspect-ratio pr. breakpoint-def.

            // Find first active breakpoint-def
            const activeBpDef = Object.keys(props.aspectRatio).find((bpDef) => breakpointsState.isBreakpointActive(bpDef));
            // Use active or default
            const result = activeBpDef ? props.aspectRatio[activeBpDef] : props.aspectRatio.default;
            if (!result) {
                throw new Error('Provide a breakpoint-definition for all cases or a default');
            }
            return result;
        });

        const autoFitVideoToAspectRatioClass = computed(() => {
            if (props.autoFitVideoToAspectRatio) {
                const videoIsLandscapeMode = activeAspectRatio.value >= 1;
                return videoIsLandscapeMode ? 'adjust-video-size-for-landscape-mode' : 'adjust-video-size-for-portrait-mode';
            }
            return '';
        });

        const style = computed(() => {
            const padding = `${(100 / activeAspectRatio.value).toFixed(2)}%`;
            return { paddingTop: padding };
        });

        const vimeoUrl = computed(() => {
            const baseUrl = 'https://player.vimeo.com/video/';
            const params = props.autoplay ? 'title=0&byline=0&portrait=0&autopause=0&background=1' : 'autoplay=false&color=f8efd7';
            return `${baseUrl}${props.srcId}?${params}`;
        });

        return {
            autoFitVideoToAspectRatioClass,
            style,
            vimeoUrl,
        };
    },
});
